import { EnvironmentProviders, Provider } from '@angular/core';
import { FpCorrelationManagerStore } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/services/fp-correlation-manager/fp-correlation-manager.store';
import { fpCorrelationSpectrumProvider } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-spectrum/fp-correlation-spectrum.providers';
import { fpCorrelationGraphProvider } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-graph/fp-correlation-graph.providers';
import { fpCorrelationSummaryProvider } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-summary/fp-correlation-summary.providers';
import { fpCorrelationCommentsProvider } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-comments/fp-correlation-comments.providers';

export function fpCorrelationProvider(): (EnvironmentProviders | Provider)[] {
  return [
    FpCorrelationManagerStore,
    // sort according to order of tabs in UI
    fpCorrelationGraphProvider(),
    fpCorrelationSpectrumProvider(),
    fpCorrelationSummaryProvider(),
    fpCorrelationCommentsProvider(),
  ];
}
